import { z } from 'zod';
import { IntlShape } from 'react-intl';
export const buildSignUpSchema = (intl: IntlShape) =>
  z
    .object({
      // Sign up simplificado (Fase 2 onboarding): pedimos solo lo mínimo —
      // nombre, email y contraseña. El resto del perfil se completa después
      // desde el OnboardingChecklist del dashboard.
      name: z
        .string()
        .min(1, {
          message: intl.formatMessage({
            id: 'home.signup.validation.nameRequired',
            defaultMessage: 'El nombre es obligatorio'
          })
        })
        .min(2, {
          message: intl.formatMessage({
            id: 'home.signup.validation.nameTooShort',
            defaultMessage: 'El nombre debe tener al menos 2 caracteres'
          })
        }),
      email: z
        .string()
        .min(1, { message: intl.formatMessage({ id: 'home.signup.validation.emailRequired' }) })
        .email({ message: intl.formatMessage({ id: 'home.signup.validation.emailInvalid' }) }),
      password: z
        .string()
        .min(1, { message: intl.formatMessage({ id: 'home.signup.validation.passwordRequired' }) })
        .min(6, { message: intl.formatMessage({ id: 'home.signup.validation.passwordTooShort' }) }),
      confirmPassword: z
        .string()
        .min(1, { message: intl.formatMessage({ id: 'home.signup.validation.confirmPasswordRequired' }) })
        .min(6, { message: intl.formatMessage({ id: 'home.signup.validation.passwordTooShort' }) }),
      userType: z.literal('coach')
    })
    .refine((data) => data.password === data.confirmPassword, {
      path: ['confirmPassword'],
      message: intl.formatMessage({ id: 'home.signup.validation.passwordMismatch' })
    });
